import React from 'react'
import { useNavigate } from 'react-router-dom'
import authentication from '../http/auth'

export default function LogoutLink(props) {
  const [disabled, setDisabled] = React.useState(false)
  const navigate = useNavigate()

  const onClick = (e) => {
    e.preventDefault()

    if (!disabled) {
      setDisabled(true)
    }

    authentication.logout()
    navigate('/login')
  }

  return (
    <a href='#' onClick={onClick} disabled={disabled}>
      {props.children ? props.children : 'Logout'}
    </a>
  )
}
